import { useCallback, useMemo } from 'react';

import type { Step } from '@bugbug/core/types/steps';
import type { Test } from '@bugbug/core/types/tests';
import { usePlaybackCursorPosition } from '~/modules/tests/hooks/usePlaybackCursorPosition/usePlaybackCursorPosition';
import { showStepError, showStepsError } from '~/modules/tests/tests.utils';
import { ACTIONS } from '~/services/toasts/internalServerError';

import { stepsApi } from '../../steps.api';

export const useToggleStepsActivation = () => {
  const [toggleStepActivation, toggleStepActivationState] =
    stepsApi.useSwitchStepsActivationStateMutation();
  const { refreshPlaybackCursorPosition } = usePlaybackCursorPosition();

  const handleToggleStepActivation = useCallback(
    async (params: { ids: Step['id'][]; isActive: boolean; testId: Test['id'] }) => {
      const result = toggleStepActivation(params).unwrap();

      result
        .then(() => {
          refreshPlaybackCursorPosition();
        })
        .catch((error) => {
          const showError = params.ids.length === 1 ? showStepError : showStepsError;
          showError(ACTIONS.UPDATE, error as Error);
        });

      return result;
    },
    [toggleStepActivation, refreshPlaybackCursorPosition],
  );

  return useMemo(
    () => [handleToggleStepActivation, toggleStepActivationState] as const,
    [handleToggleStepActivation, toggleStepActivationState],
  );
};
